;(function(){

	var colours = {
		red: '#e7352a',
		grey: '#edf4fa',
		offwhite: '#F6FAFD',
		white: '#FFFFFF'
	};

	var defaults = {
		height: 40,
		fill: 'grey',
		position: 'above',
		align: 'outside',
		animated: false,
		inverted: false
	};

	// http://p5js.org/examples/examples/Math_Noise_Wave.php
	// http://codepen.io/ryanmcnz/pen/EDtun
	$('[data-wave]')
		.each(function(i){

			var $root = $(this);

			var data = $root.data(),
				options = $.extend({}, defaults, data),
				wave = {},
				totalP = 3,
				p = [],
				width,
				height;

			var $canvas = $('<canvas>', {
					id: 'wave-' + ( i + 1 )
				});

			var canvas = $canvas[0],
				ctx = canvas.getContext('2d');

			$canvas.prependTo($root);

			$root
				.addClass('waves')
				.addClass('waves--' + options.position)
				.addClass('waves--' + options.align);

			if( options.inverted )
				$root.addClass('waves--inverted');

			var animatePoint = function(i, yoyo){

				/*TweenLite
					.to(p[i], 5, {
						y: yoyo ? 0 : height,
						onUpdate: function(){
							console.log(p[i].y);
						},
						onComplete: function(){

							if( p[i].y >= height ){
								animatePoint(i, true);
							}else if( p[i].y <= 0 ){
								animatePoint(i);
							}

						}
					});*/

			};

			var draw = function(){

				ctx.clearRect(0, 0, wave.width, wave.height);

				ctx.beginPath();

				var seg = wave.width / 3,
					off = wave.height * 1.5;

				ctx.moveTo(0, wave.height / 2);
				ctx.bezierCurveTo(seg, wave.height - off, seg, off, seg * 2, wave.height / 2);
				ctx.bezierCurveTo(seg * 3, wave.height - off, seg * 3, off, seg * 4, wave.height / 2);
				ctx.lineTo(seg * 4, wave.height);
				ctx.lineTo(0, wave.height);
				ctx.closePath();

				ctx.fillStyle = colours[options.fill];

				ctx.fill();

			};

			var layout = function(){

				width = $root.innerWidth() * 2;
				height = site.width / 10;

				if( height > options.height * 2 )
					height = options.height * 2;

				var pSegment = width / 2,
					cpOffset = pSegment / 8,
					cY = 0,
					yInc = height / 2,
					yoyo = false;

				for( var i = totalP - 1; i >= 0; i-- ){

					var x = pSegment * i,
						y = cY;

					if( yoyo ){
						cY = cY - yInc;
					}else{
						cY = cY + yInc;
					}

					if( cY <= 0 ){
						cY = 0;
						yoyo = true;
					}else if( cY >= height ){
						cY = height;
						yoyo = false;
					}

					p[i] = {
						x: x,
						y: y,
						cp1: {
							x: x - cpOffset,
							y: y
						},
						cp2: {
							x: x + cpOffset,
							y: y
						}
					}

					animatePoint(i);

				};

				$canvas
					.prop({
						width: width,
						height: height
					})
					.css({
						width: '100%',
						height: height / 2
					});

				wave = {
					width: width,
					height: height
				};

				draw();

			};

			layout();

			site.resize.after['wave-' + i] = layout;

		});

}());